import * as fromDatatype from '../datatype-library/index';
export interface bl_fi_mst_entity_branch_hdr_RowInterface {
  guid : fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  address_line_1: fromDatatype.VarcharDatatypeInterface;
  address_line_2: fromDatatype.VarcharDatatypeInterface;
  address_line_3: fromDatatype.VarcharDatatypeInterface;
  address_line_4: fromDatatype.VarcharDatatypeInterface;
  address_line_5: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  geoloc_latitude: fromDatatype.NumericDatatypeInterface;
  geoloc_longitude: fromDatatype.NumericDatatypeInterface;
  xtn_mapping_source_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_column_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_fieldname_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_01: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_column_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_fieldname_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_02: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_column_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_fieldname_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_03: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_column_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_fieldname_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_04: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_source_05: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_table_05: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_column_05: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_fieldname_05: fromDatatype.VarcharDatatypeInterface;
  xtn_mapping_value_05: fromDatatype.VarcharDatatypeInterface;
  address_name: fromDatatype.TextDatatypeInterface;
  mobile_no: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  control_account_code: fromDatatype.VarcharDatatypeInterface;
  control_account_arap_type: fromDatatype.VarcharDatatypeInterface;
  control_account_glcode_guid: fromDatatype.GuidDataFieldInterface;
  control_account_subledger_guid: fromDatatype.GuidDataFieldInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_desc: fromDatatype.TextDatatypeInterface;
  delivery_contact_person: fromDatatype.VarcharDatatypeInterface;
  billing_contact_person: fromDatatype.VarcharDatatypeInterface;
  billing_address_line_1: fromDatatype.TextDatatypeInterface;
  billing_address_line_2: fromDatatype.TextDatatypeInterface;
  billing_address_line_3: fromDatatype.TextDatatypeInterface;
  billing_address_line_4: fromDatatype.TextDatatypeInterface;
  billing_address_line_5: fromDatatype.TextDatatypeInterface;
  billing_postal_code: fromDatatype.VarcharDatatypeInterface;
  billing_city: fromDatatype.VarcharDatatypeInterface;
  billing_state: fromDatatype.VarcharDatatypeInterface;
  billing_country: fromDatatype.VarcharDatatypeInterface;
  billing_address_name: fromDatatype.VarcharDatatypeInterface;
  billing_email: fromDatatype.VarcharDatatypeInterface;
  billing_phone: fromDatatype.VarcharDatatypeInterface;
  billing_mobile_phone: fromDatatype.VarcharDatatypeInterface;
  entity_branch_group_hdr_guid: fromDatatype.GuidDataFieldInterface;
  credit_terms_day: fromDatatype.NumericDatatypeInterface;
  credit_limit: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_mst_entity_branch_hdr_RowClass implements bl_fi_mst_entity_branch_hdr_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    address_line_1: fromDatatype.VarcharDatatypeInterface;
    address_line_2: fromDatatype.VarcharDatatypeInterface;
    address_line_3: fromDatatype.VarcharDatatypeInterface;
    address_line_4: fromDatatype.VarcharDatatypeInterface;
    address_line_5: fromDatatype.VarcharDatatypeInterface;
    postal_code: fromDatatype.VarcharDatatypeInterface;
    city: fromDatatype.VarcharDatatypeInterface;
    state: fromDatatype.VarcharDatatypeInterface;
    country: fromDatatype.VarcharDatatypeInterface;
    geoloc_latitude: fromDatatype.NumericDatatypeInterface;
    geoloc_longitude: fromDatatype.NumericDatatypeInterface;
    xtn_mapping_source_01: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_table_01: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_column_01: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_fieldname_01: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_value_01: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_source_02: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_table_02: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_column_02: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_fieldname_02: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_value_02: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_source_03: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_table_03: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_column_03: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_fieldname_03: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_value_03: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_source_04: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_table_04: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_column_04: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_fieldname_04: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_value_04: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_source_05: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_table_05: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_column_05: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_fieldname_05: fromDatatype.VarcharDatatypeInterface;
    xtn_mapping_value_05: fromDatatype.VarcharDatatypeInterface;
    address_name: fromDatatype.TextDatatypeInterface;
    mobile_no: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    control_account_code: fromDatatype.VarcharDatatypeInterface;
    control_account_arap_type: fromDatatype.VarcharDatatypeInterface;
    control_account_glcode_guid: fromDatatype.GuidDataFieldInterface;
    control_account_subledger_guid: fromDatatype.GuidDataFieldInterface;
    input_tax_type: fromDatatype.VarcharDatatypeInterface;
    input_tax_code: fromDatatype.VarcharDatatypeInterface;
    input_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_tax_type: fromDatatype.VarcharDatatypeInterface;
    output_tax_code: fromDatatype.VarcharDatatypeInterface;
    output_tax_rate: fromDatatype.NumericDatatypeInterface;
    output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
    output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
    output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
    input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
    input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
    input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
    einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
    einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
    einvoice_taxable_type_desc: fromDatatype.TextDatatypeInterface;
    delivery_contact_person: fromDatatype.VarcharDatatypeInterface;
    billing_contact_person: fromDatatype.VarcharDatatypeInterface;
    billing_address_line_1: fromDatatype.TextDatatypeInterface;
    billing_address_line_2: fromDatatype.TextDatatypeInterface;
    billing_address_line_3: fromDatatype.TextDatatypeInterface;
    billing_address_line_4: fromDatatype.TextDatatypeInterface;
    billing_address_line_5: fromDatatype.TextDatatypeInterface;
    billing_postal_code: fromDatatype.VarcharDatatypeInterface;
    billing_city: fromDatatype.VarcharDatatypeInterface;
    billing_state: fromDatatype.VarcharDatatypeInterface;
    billing_country: fromDatatype.VarcharDatatypeInterface;
    billing_address_name: fromDatatype.VarcharDatatypeInterface;
    billing_email: fromDatatype.VarcharDatatypeInterface;
    billing_phone: fromDatatype.VarcharDatatypeInterface;
    billing_mobile_phone: fromDatatype.VarcharDatatypeInterface;
    entity_branch_group_hdr_guid: fromDatatype.GuidDataFieldInterface;
    credit_terms_day: fromDatatype.NumericDatatypeInterface;
    credit_limit: fromDatatype.NumericDatatypeInterface;
}
